import { type AwsRumConfig } from 'aws-rum-web';

const SESSION_REPLAY_SAMPLE_RATE = 0.1;

type RumSettings = {
  identityPoolId: string;
  region: string;
};

export const buildRumConfig = ({ identityPoolId, region }: RumSettings): AwsRumConfig => ({
  sessionSampleRate: 1,
  identityPoolId,
  endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
  telemetries: [
    'performance',
    'errors',
    'http',
    ['replay', { additionalSampleRate: SESSION_REPLAY_SAMPLE_RATE }],
  ],
  allowCookies: true,
  enableXRay: true,
});
